module.exports = __webpack_public_path__ + "img/backpack.15f9a9e7.png";